module.exports = __webpack_public_path__ + "img/doc.04cadbc9.png";